import { formatShortDate } from './dateLocale';

/**
 * A date with no time of day — a report date, an assessment date. MYM-260 leaves these outside time
 * zone conversion: they name a calendar day, so they are read exactly as the API wrote them.
 * Reading a bare `YYYY-MM-DD` with `new Date()` puts it at UTC midnight, which is the day before for
 * any guardian west of UTC — hence rebuilding the written day below.
 */
export const parseDayOnly = (value: string): Date | undefined => {
  const parsed = new Date(value);

  if (Number.isNaN(parsed.getTime())) return undefined;

  const isBareDay = /^\d{4}-\d{2}-\d{2}$/.test(value.trim());

  return isBareDay ? new Date(parsed.getUTCFullYear(), parsed.getUTCMonth(), parsed.getUTCDate()) : parsed;
};

export const formatDayOnly = (value: string, locale?: string): string => {
  const day = parseDayOnly(value);

  return day ? formatShortDate(day, locale) : '';
};
